import {AxiosCall, CancelTokenSource} from '../axios';
import {serializeQueryParams} from './PaymentHistoryService';

export const getAllClaims = async (
  groupId: number | string,
  clinicId: number | string,
  options: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const queryParams = serializeQueryParams(options);

  const url = `/clinic-group/${groupId}/clinic/${clinicId}/claim/all?${queryParams}`;
  return AxiosCall.get(url, cancelToken);
};

export const getClaimDetailsByID = async (
  groupId: number,
  clinicId: number,
  claimId: number
): Promise<any> => {
  const url = `/clinic-group/${groupId}/clinic/${clinicId}/claim/${claimId}`;
  return AxiosCall.get(url);
};

export const getClaimMetrics = async (
  groupId: number,
  clinicId: number,
  options: any
): Promise<any> => {
  const queryParams = serializeQueryParams(options);
  return AxiosCall.get(
    `/clinic-group/${groupId}/clinic/${clinicId}/claim/metrics?${queryParams}`
  );
};

export const SendClaim = async (
  groupId: number,
  clinicId: number,
  claimId: number
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${groupId}/clinic/${clinicId}/claim/${claimId}/send`,
    {}
  );
};

export const getMonthlyTrend = async (
  groupId: number | string,
  clinicId: number | string,
  params: {year: number; date_field: string; month?: number}
): Promise<any> => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.get(
    `/clinic-group/${groupId}/clinic/${clinicId}/claim/monthly-trend?${queryParams}`
  );
};

export const downloadMonthlyTrend = async (
  groupId: number | string,
  clinicId: number | string,
  params: {year: number; date_field: string; month?: number; format: 'csv' | 'excel'}
): Promise<any> => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.getFileData(
    `/clinic-group/${groupId}/clinic/${clinicId}/claim/monthly-trend/export?${queryParams}`
  );
};

export const getSubmissionTurnaround = async (
  groupId: number | string,
  clinicId: number | string,
  params: {date_min: string; date_max: string}
): Promise<any> => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.get(
    `/clinic-group/${groupId}/clinic/${clinicId}/claim/submission-turnaround?${queryParams}`
  );
};

export const downloadSubmissionTurnaround = async (
  groupId: number | string,
  clinicId: number | string,
  params: {date_min: string; date_max: string; format: 'csv' | 'excel'}
): Promise<any> => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.getFileData(
    `/clinic-group/${groupId}/clinic/${clinicId}/claim/submission-turnaround/export?${queryParams}`
  );
};

export const getPayerPerformance = async (
  groupId: number | string,
  clinicId: number | string,
  params: {date_min: string; date_max: string}
): Promise<any> => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.get(
    `/clinic-group/${groupId}/clinic/${clinicId}/claim/payer-performance?${queryParams}`
  );
};

export const downloadPayerPerformance = async (
  groupId: number | string,
  clinicId: number | string,
  params: {date_min: string; date_max: string; format: 'csv' | 'excel'}
): Promise<any> => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.getFileData(
    `/clinic-group/${groupId}/clinic/${clinicId}/claim/payer-performance/export?${queryParams}`
  );
};
